// @flow

import React from 'react';
import CustomerProfileGraph from './components/CustomerProfileGraph';
import Loader from '../../../common/Loader';
import type { CameoGroupsBean } from '../../../../types/apolloType';
import MarketingEmptyTile from './MarketingEmptyTile';

type Props = {
  customerProfile: ?CameoGroupsBean,
  isLoading: boolean,
}

function CustomerProfile({ customerProfile, isLoading }: Props) {
  if (isLoading) {
    return (
      <Loader isLoading />
    );
  }
  if (!customerProfile
      || !customerProfile.cameoGroupsByShoppingCenter
      || customerProfile.cameoGroupsByShoppingCenter.length < 1
  ) {
    return (
      <MarketingEmptyTile errorMessage="MKT_PAGE.NO_DATA_CACI" />
    );
  }

  return (
    <div className="customer-profile">
      <CustomerProfileGraph data={customerProfile} />
    </div>
  );
}

export default CustomerProfile;
